import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useMainContentDimensions from "../../../utils/mainContentDimensions";

import {
  Card,
  CardHeader,
  Breadcrumbs as MuiBreadcrumbs,
  Paper as MuiPaper,
  CardContent,
} from "@mui/material";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import Toolbar from "../../../components/Toolbar";
import useWindowDimensions from "../../../utils/windowDimensions";
import useAuthenticationLog from "../../../hooks/useAuthenticationLog";
import moment from "moment";

function AuthenticationLogs({ userName }) {
  const { t } = useTranslation();

  const currentPayload = {
    filters: [
      {
        fieldName: "userName",
        fieldValue: userName,
        op: "eq",
        dataType: "string",
        condition: "and",
        isJoin: false,
      },
    ],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [
      {
        field: "authDate",
        sort: "DESC",
      },
    ],
  };

  const [sortModel, setSortModel] = useState([
    {
      field: "authDate",
      sort: "desc",
    },
  ]);
  const { height } = useWindowDimensions();
  const { getAllAuthenticationLog, authenticationLogs, paging, downloadFile } =
    useAuthenticationLog();
  const { width: mainContentWidth } = useMainContentDimensions();

  const [payload, setPayload] = useState(currentPayload);

  const fetchData = async () => {
    await getAllAuthenticationLog(payload);
  };

  const [filterResetFunc, setFilterResetFunc] = useState(
    () => () => console.log("Refresh initialized"),
  );

  const refreshPage = () => {
    setPayload(currentPayload);
    filterResetFunc();
  };

  const handlePaginationModelChange = (model) => {
    setPayload((prev) => ({
      ...prev,
      pagination: {
        pageNumber: model.page + 1,
        pageSize: model.pageSize,
      },
    }));
  };

  useEffect(() => {
    fetchData();
  }, [payload]);

  const handleSortModelChange = (newModel) => {
    console.log(newModel, "newModel");
    if (newModel.length !== 0) {
      setSortModel(newModel);
      setPayload((prev) => ({ ...prev, sortFields: newModel }));
    }
  };

  const columns = [
    {
      field: "userName",
      headerName: "User Name",
      width: 200,
    },
    {
      field: "authDate",
      headerName: "Authentication Date",
      valueGetter: (params) => moment(params).format("DD-MM-YYYY HH:mm a"),
      width: 200,
    },
    {
      field: "reply",
      headerName: "Reply",
      width: 400,
    },
    {
      field: "reason",
      headerName: "Reason",
      width: 400,
    },
  ];

  return (
    <Card sx={{ width: "100%" }}>
      <CardHeader
        action={
          <Toolbar downloadFile={(type) => downloadFile(type, payload)} refreshPage={refreshPage} />
        }
        title={t("authentication_logs")}
        // subheader={breadCrump()}
        downloadFile={downloadFile}
      />
      <CardContent sx={{ height: height - 180 }}>
        <DataGrid
          columns={columns}
          rows={authenticationLogs}
          getRowId={(row) => row["id"]}
          rowCount={paging.totalNumberOfRecords}
          loading={false}
          rowsPerPageOptions={[5]}
          pagination
          paginationMode="server"
          paginationModel={{
            page: paging.pageNumber > 0 ? paging.pageNumber - 1 : 0,
            pageSize: paging.pageSize || 100,
          }}
          onPaginationModelChange={handlePaginationModelChange}
          sortingMode="server"
          sortModel={sortModel}
          onSortModelChange={handleSortModelChange}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row"
          }
          sx={{
            "& .MuiDataGrid-row.even-row": {
              backgroundColor: "#f9f9f9", // Light gray for even rows
            },
            "& .MuiDataGrid-row.odd-row": {
              backgroundColor: "#ffffff", // White for odd rows
            },
          }}
        />
      </CardContent>
    </Card>
  );
}

export default AuthenticationLogs;
